import React from 'react';
import { Radio, RadioGroup } from 'rsuite';
import { ValueType } from 'rsuite/esm/Radio';
import { ExpressRegistrationRegistrant } from 'src/types/configuration';
import { REGISTRANT_OPTIONS } from 'src/types/flow';

interface RegistrantRadioGroupProps {
  configuration: ExpressRegistrationRegistrant;
  value?: REGISTRANT_OPTIONS;
  onChange?: (value: REGISTRANT_OPTIONS) => void;
  disabled?: boolean;
}

export const RegistrantRadioGroup = ({
  value,
  onChange,
  configuration,
  disabled,
}: RegistrantRadioGroupProps) => {
  const handleRadioGroupChange = (value: ValueType) => {
    if (onChange) {
      onChange(value as REGISTRANT_OPTIONS);
    }
  };
  return (
    <RadioGroup
      name="radio-option-group"
      value={value}
      onChange={handleRadioGroupChange}
      disabled={disabled}
    >
      {configuration?.property_owner && (
        <Radio value={REGISTRANT_OPTIONS.OWNER}>Yes, I&apos;m the owner</Radio>
      )}
      {configuration?.property_manager && (
        <Radio value={REGISTRANT_OPTIONS.PROPERTY_MANAGER}>
          No, I&apos;m a property manager
        </Radio>
      )}
      {configuration?.tenant && (
        <Radio value={REGISTRANT_OPTIONS.TENANT}>No, I&apos;m a tenant</Radio>
      )}
    </RadioGroup>
  );
};
